import React from "react";
import Select from "react-dropdown-select";
import invariant from "ts-invariant";

import Icon from "../../../icons/Icon";
import { Container } from "./styles";

import { Box } from "../ResponsiveBox";

interface Props {
  id?: string;
  options: {
    label: string;
    value: string;
  }[];
  label?: string;
  ariaLabel?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  hidden?: boolean;
  errors?: string[];
  small?: boolean;
  smallDropdown?: boolean;
}

const ReactSelect: React.FC<Props> = ({
  options,
  label,
  ariaLabel,
  placeholder = "",
  value,
  onChange,
  hidden,
  errors,
  small = false,
  smallDropdown = false,
  ...rest
}) => {
  const handleAriaLabel = () => {
    if (label || ariaLabel || hidden) return true;
    if (!label && !ariaLabel && !hidden) return false;
  };

  invariant(handleAriaLabel(), "Must provide aria-label or label");

  const handleOnChange = (option: { label: string; value: string }[]) => {
    if (onChange) onChange(option[0].value);
  };

  return (
    <Container
      className="form__input"
      alignItems="stretch"
      errors={errors || []}
      small={small}
      smallDropdown={smallDropdown}
    >
      {label && <label htmlFor={rest.id}>{label}</label>}

      <Select
        {...rest}
        searchable={false}
        placeholder={placeholder}
        options={options}
        values={value ? [options[0]] : []}
        onChange={handleOnChange}
        dropdownHandleRenderer={({ state }) => (
          <Box mR="md">
            <Icon
              name={state.dropdown ? "chevron-up" : "chevron-down"}
              size={16}
              fill="neutral.500"
            />
          </Box>
        )}
      />
    </Container>
  );
};

export default ReactSelect;
